import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { BaseSelect as Select } from '@alfa-bank/site-form-utils/components/base-select';

import { EmailField as Component } from './email-field';
import type { TEmailField, IDeps } from './models';

export const EmailField = createWidget<IDeps, TEmailField>({
    Select,
})(Component);
